module.exports = __webpack_public_path__ + "img/3.0c1da898.jpg";